import { HBO_ELIGIBLE_ACTIVATION_STATUSES } from 'containers/HboActivation/constants';

const isHboActivationItem = item =>
  item?.type === 'activation_flow' && item?.external_activation_app === 'hbo';

// El item de activacion solo se muestra con las 4 condiciones cumplidas. Cualquier valor
// ausente (undefined / null, por ejemplo mientras el status todavia carga) lo deja en false:
// aca el comportamiento conservador es NO mostrarlo hasta tener todos los datos.
const canShowHboActivationItem = ({
  isAdmin,
  isHboSubscribed,
  isFlagEnabled,
  hboStatus,
} = {}) =>
  Boolean(
    isAdmin &&
      isHboSubscribed &&
      isFlagEnabled &&
      HBO_ELIGIBLE_ACTIVATION_STATUSES.includes(hboStatus),
  );

export const filterHboActivationItems = (items, hboContext = {}) => {
  if (!Array.isArray(items)) return items;
  const shouldShowActivationFlow = canShowHboActivationItem(hboContext);

  return items.filter(item =>
    isHboActivationItem(item) ? shouldShowActivationFlow : true,
  );
};


export const mapSuperhighlightResponse = response => {
  if (!response) return [];

  const items =
    response?.data?.highlight ?? // v4
    response?.response?.highlight ?? // v1
    [];

  return items;
};
